/** HEIC/HEIF are iPhone defaults; browser <canvas> can't decode them, so we
 *  refuse the upload up-front instead of silently storing a huge raw file. */
export function isHeicImage(file) {
  if (!file) return false;
  const type = (file.type || "").toLowerCase();
  const name = (file.name || "").toLowerCase();
  return (
    type === "image/heic" ||
    type === "image/heif" ||
    name.endsWith(".heic") ||
    name.endsWith(".heif")
  );
}

export const HEIC_HELP =
  "HEIC isn't supported in browsers. On iPhone: Settings → Camera → Formats → 'Most Compatible', then re-take the photo as JPEG. Or share via Mail/Messages which auto-converts.";

/**
 * Resize + compress an image File to a JPEG data URL in the browser.
 *
 * Default ~1600px max dimension at JPEG quality 0.8 typically reduces a 4 MB
 * phone photo to 200-400 KB while still looking great in the recipe card.
 */
export async function compressImageFile(
  file,
  { maxWidth = 1600, maxHeight = 1600, quality = 0.8, mime = "image/jpeg" } = {}
) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        let { width, height } = img;
        if (width > maxWidth || height > maxHeight) {
          const scale = Math.min(maxWidth / width, maxHeight / height);
          width = Math.round(width * scale);
          height = Math.round(height * scale);
        }
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL(mime, quality));
      };
      img.onerror = () => reject(new Error("Could not decode image"));
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
